export const APP_CONFIG = {
  NAME: 'S&S Engineering App',
  VERSION: '1.0.0',
  BASE_URL: process.env.REACT_APP_BASE_URL || 'https://sandsengineering.co.in',
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://api.sandsengineering.co.in/api',
  // API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api',
  TOKEN_KEY: 'idToken',
  THEME_KEY: 'theme-mode',
} as const;

export const USER_ROLES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  EMPLOYEE: 'employee',

} as const;

export const COMPONENT_SIZE_LIMIT = 500